<template>
    <div class="login-container">
        <img src="@/assets/imgs/login_bg.png" class="logo" />
        <div class="welcome">
            <b>HI！</b>
            <p>欢迎来到博览中国</p>
        </div>
        <div class="content">
            <div class="form_container">
                <!-- 登录 -->
                <div v-if="!isRegister">
                    <Login @register="isRegister = true" />
                </div>
                <!-- 注册 -->
                <div class="register_form" v-else>
                    <Register @login="isRegister = false" />
                </div>
            </div>
        </div>
    </div>


</template>
<script setup>
import { ref } from 'vue';
import Login from './Login.vue'
import Register from './Register.vue'

const isRegister = ref(false)
</script>

<style scoped lang="scss">
.login-container {
    height: 100vh;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: linear-gradient(180deg, #EFF6FE 0%, #FFFFFF 100%);
    position: relative;
    padding-top: 200rem;
    overflow-x: hidden;
    .logo {
        width: 300rem;
        position: absolute;
        right: -50rem;
        // top: 50rem;
        top: calc(50vh - 450rem);
    }

    .welcome {
        position: absolute;
        display: flex;
        flex-direction: column;
        // align-items: center;
        justify-content: center;
        // top: 150rem;
        top: calc(50vh - 300rem);
        left: 100rem;
        transform: translate(-50%, -50%);

        b {
            color: #726FF9;
            font-size: 30rem;

        }

        p {
            color: #919191;
            font-size: 14rem;
        }
    }

    .content {
        width: 350rem;
        border-radius: 10px;
        position: relative;
        z-index: 1;
    }


}
</style>